// this is an autogenerated file from DesignSystem/LeadPreview/Content/Notes/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_LeadPreview_Content_Notes(
  $note_id: uuid!
  $lead_id: uuid!
  $notes: String!
  $create_note: Boolean!
  $update_note: Boolean!
) {
  insert_leads_notes_one(object: { lead_id: $lead_id, notes: $notes })
    @include(if: $create_note) {
    id
  }
  update_leads_notes_by_pk(
    pk_columns: { id: $note_id }
    _set: { notes: $notes }
  ) @include(if: $update_note) {
    id
  }
}

`